import React from 'react';
const StateMachine = require('javascript-state-machine');

//todo get default status
export const verificationStatusStateMachine = new StateMachine({
  initial: '',
  transitions: [
    {
      name: 'Missing',
      from: 'Verified',
      to: 'Missing',
    },
    {
      name: 'Verified',
      from: 'Missing',
      to: 'Verified',
    },
    {
      name: 'Missing',
      from: 'Salvaged',
      to: 'Missing',
    },
    {
      name: 'Transfer Approved',
      from: 'Transfer Request',
      to: 'Transfer Approved',
    },
    {
      name: 'Transfer Denied',
      from: 'Transfer Request',
      to: 'Transfer Denied',
    },
    {
      name: 'Salvage Approved',
      from: 'Salvage Request',
      to: 'Salvage Approved',
    },
    {
      name: 'Salvage Denied',
      from: 'Salvage Request',
      to: 'Salvage Denied',
    },
    {
      name: 'goto',
      from: '*',
      to: function (s) {
        return s;
      },
    },
  ],
  methods: {},
});

export const initializeState = (state) => {
  verificationStatusStateMachine.goto(state);

  // console.log('All States: ' + verificationStatusStateMachine.allStates());
  // console.log('Current State: ' + verificationStatusStateMachine.state);
  // console.log('Allowed Transitions: ' + verificationStatusStateMachine.transitions());
  // console.log('All Transitions: ' + verificationStatusStateMachine.allTransitions());
};

export const getOptions = (status) => {
  initializeState(status);
  // console.log('Allowed Transitions: ' + verificationStatusStateMachine.transitions());
  return verificationStatusStateMachine.transitions();
};

export const VerificationStatuses = (props) => {
  const [options, setOptions] = React.useState([]);
  let status = props.formik.values.status;

  React.useEffect(() => {
    setOptions(getOptions(status));
  }, [status]);

  return (
    <div className='form-group form-inline'>
      <label className='col-sm-3'>Status</label>
      <select
        className='form-control col-sm-8'
        id='status'
        name='status'
        onChange={props.formik.handleChange}
        value={props.formik.values.status}
        defaultValue={1}>
        <option value={status}>{status}</option>
        {options.map((value, index) => {
          if (value !== 'goto') {
            return <option value={value}>{value}</option>;
          }
          return ''
        })}
      </select>
    </div>
  );
};

export default VerificationStatuses;
